import { inject, Injectable } from "@angular/core";
import { GlossSyncService } from "../../gloss.sync.service";
import { AppStateStoreService } from "../../../store/app-state/app-state.store.service";
import { BasiqAuthApi } from "@bitwarden/web-vault/app/services/syncing/basiq/api/basiq.api.auth";

@Injectable({
  providedIn: "root",
})
export class BasiqValidator {
  protected glossSyncService: GlossSyncService;
  protected appState: AppStateStoreService;
  protected basiqAuthApi: BasiqAuthApi;

  constructor() {
    this.glossSyncService = inject(GlossSyncService);
    this.appState = inject(AppStateStoreService);
    this.basiqAuthApi = inject(BasiqAuthApi);
  }
}
